/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link, Redirect } from "react-router-dom";

import { Button, Form, Input, message } from "antd";

import { withTranslation } from "react-i18next";
import { connect, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import ButtonLoader from "../../components/ButtonLoader";
import { requestApiAuth } from "../../store/actions/actions";
import { storeAuthToken } from "../../store/actions/auth.action";

import styles from "./Login.module.css";

const Login = (props) => {
  const guest = props.data.guest;
  const [redirect, setRedirect] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const removeLocalStorage = () => {
    sessionStorage.removeItem("access_token");
    sessionStorage.removeItem("x-refresh-token");
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("id");
    sessionStorage.removeItem("redirect");
    sessionStorage.removeItem("mail_guest");
    sessionStorage.removeItem("nom");
    sessionStorage.removeItem("prenom");
    sessionStorage.removeItem("mail");
    sessionStorage.removeItem("company");
    sessionStorage.removeItem("start_date");
    sessionStorage.removeItem("duration");
  };

  const removeAuthFromStore = () => {
    dispatch(storeAuthToken(""));
  };

  useEffect(() => {
    document.title = `${props.t("home.login")} - Wifi Guest`;
    removeLocalStorage();
    removeAuthFromStore();
    let queryString = props.location.search;
    let urlParams = new URLSearchParams(queryString);
    let reseau = urlParams.get("reseau");
    let station_ip = urlParams.get("station_ip");
    if (reseau && reseau !== null) {
      sessionStorage.setItem("reseau", reseau);
      sessionStorage.setItem("station_ip", station_ip);
      window.history.pushState("clear", "", "/");
    }
  }, []);

  const authHandler = (values) => {
    setLoading(true);
    props.requestApiAuth({
      body: {
        login: values.login,
        password: values.password,
        reseau: sessionStorage.getItem("reseau"),
        station_ip: sessionStorage.getItem("station_ip"),
      },
      callback: (status) => {
        if (status === 200) {
          setRedirect(true);
        } else if (status === 500) {
          message.warn(<span style={{ marginLeft: "5px" }}>{props.t("home.server.issue")}</span>);
          setLoading(false);
        } else {
          if (!sessionStorage.getItem("reseau") || !sessionStorage.getItem("station_ip")) {
            message.error(<span style={{ marginLeft: "5px" }}>{props.t("home.server.miss_wifi")}</span>);
          } else {
            message.error(<span style={{ marginLeft: "5px" }}>{props.t("home.server.miss_log")}</span>);
          }
          setLoading(false);
        }
      },
    });
  };

  const t = props.t;

  if (redirect) {
    return (
      <Redirect
        to={`/welcome?nom=${guest.firstName}&prenom=${guest.lastName}&mail=${guest.guest}&company=${guest.company}&startAt=${guest.startAt}&validity_period=${guest.validity_period}`}
      />
    );
  }

  return (
    <div className="auth-inner">
      <h3>{t("home.titleLogin")} - Wifi Guest</h3>
      <Form name="basic" onFinish={authHandler} autoComplete="off" layout="vertical" className={styles.form}>
        <Form.Item
          label={t("home.label.login")}
          name="login"
          className={styles.input_item}
          rules={[
            {
              required: true,
              message: t("home.validation.login"),
            },
          ]}
        >
          <Input placeholder={t("home.placeholder.login")} />
        </Form.Item>
        <Form.Item
          label={t("home.label.password")}
          name="password"
          className={styles.input_item}
          rules={[
            {
              required: true,
              message: t("home.validation.password"),
            },
          ]}
        >
          <Input.Password placeholder={t("home.placeholder.password")} />
        </Form.Item>
        <div className="form-submit">
          <ButtonLoader
            loading={loading}
            text={t("home.login")}
            position="none"
            type="primary"
            style={{ width: "100%" }}
            onClick={() => {
              authHandler();
            }}
          />
          <p className="forgot-password">
            {t("home.noAccountMsg")}
            <Link to={"/request-account"}> {t("home.requestAccountLink")}</Link>
          </p>
          <p className="forgot-password">
            {t("home.problemMsg")}
            <a
              href="https://cdn-cspn.helpline.fr/0/30ca80035e0add2dae3161c899a031a0574ff1d3/NOTICE_DE_CONNEXION_AU_WIFI_GUEST_PORTRAIT.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t("home.documentationLink")}
            </a>
          </p>
        </div>
      </Form>
      <div className="or-contener">
        <div className="or">{t("home.or")}</div>
      </div>
      <Button
        type="primary"
        danger
        style={{
          width: "100%",
        }}
      >
        <Link to={"/sso-connect"}> {props.t("home.loginSSO")}</Link>
      </Button>
    </div>
  );
};

const mapStateToProps = (state) => ({ data: state.data });

const mapDispatchToProps = (dispatch) => bindActionCreators({ requestApiAuth, storeAuthToken }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Login));
